// 导入自己需要的组件
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { ElNotification, ElMessageBox } from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

const element = {
  install: function(app) {
    app.use(ElementPlus, {
      locale: zhCn,
      message: {
        max: 1
      },
      notification: {
        max: 1
      }
    }
    )

    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    // Register global methods
    app.config.globalProperties.$notify = ElNotification
    app.config.globalProperties.$msgbox = ElMessageBox
    app.config.globalProperties.$alert = ElMessageBox.alert
    app.config.globalProperties.$confirm = ElMessageBox.confirm
    app.config.globalProperties.$prompt = ElMessageBox.prompt

    // Register loading directive
    // app.use(ElLoading.directive)
  }
}
export default element
